<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>公告与链接管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="tips">
        统一维护前台外链配置包。保存时仅覆盖页面受管字段，原 JSON 中未纳入页面维护的历史字段会继续保留。
      </div>
      <div class="page-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openCreate">新增配置</el-button>
      </div>
      <el-table :data="list" border stripe class="config-table">
        <el-table-column prop="tenantId" label="租户" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ getTenantName(scope.row.tenantId) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lang" label="语言" min-width="100">
          <template slot-scope="scope">
            <span>{{ getLangLabel(scope.row.lang) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="liveAuthType" label="实名认证方式" min-width="140" show-overflow-tooltip />
        <el-table-column prop="lardingPageUrl" label="app下载" min-width="220" show-overflow-tooltip />
        <el-table-column prop="helpCenter" label="帮助中心" min-width="220" show-overflow-tooltip />
        <el-table-column prop="noticeCenter" label="公告中心" min-width="220" show-overflow-tooltip />
        <el-table-column prop="noticeUrl" label="公告中心数据源" min-width="240" show-overflow-tooltip />
        <el-table-column prop="aboutUs" label="关于我们" min-width="220" show-overflow-tooltip />
        <el-table-column prop="userAgreemen" label="用户协议" min-width="220" show-overflow-tooltip />
        <el-table-column prop="privacy" label="隐私政策" min-width="220" show-overflow-tooltip />
        <el-table-column prop="cooperation" label="商务合作" min-width="220" show-overflow-tooltip />
        <el-table-column prop="instructions" label="使用条款" min-width="220" show-overflow-tooltip />
        <el-table-column prop="feeExplain" label="费率说明" min-width="220" show-overflow-tooltip />
        <el-table-column prop="vipRuleExplain" label="VIP规则说明" min-width="220" show-overflow-tooltip />
        <el-table-column prop="copyRule" label="跟单规则" min-width="220" show-overflow-tooltip />
        <el-table-column prop="copyAgreement" label="跟单申请协议" min-width="220" show-overflow-tooltip />
        <el-table-column prop="contractAgreement" label="合约协议" min-width="220" show-overflow-tooltip />
        <el-table-column prop="disclaimer" label="免责声明" min-width="220" show-overflow-tooltip />
        <el-table-column prop="riskWarning" label="风险提示" min-width="220" show-overflow-tooltip />
        <el-table-column prop="iosGoogleDownload" label="谷歌验证器ios" min-width="220" show-overflow-tooltip />
        <el-table-column prop="androidGoogleDownload" label="谷歌验证器android" min-width="220" show-overflow-tooltip />
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="dialogMode === 'create' ? '新增配置' : '编辑配置'"
      :visible.sync="dialogVisible"
      width="720px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="租户" prop="tenantId">
          <el-select v-model="form.tenantId" placeholder="请选择租户" :disabled="dialogMode === 'edit'" filterable>
            <el-option
              v-for="item in tenantList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="语言" prop="lang">
          <el-select v-model="form.lang" placeholder="请选择语言" :disabled="dialogMode === 'edit'">
            <el-option
              v-for="item in langOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="实名认证方式" prop="liveAuthType">
          <el-input v-model.trim="form.liveAuthType" />
        </el-form-item>
        <el-form-item label="app下载" prop="lardingPageUrl">
          <el-input v-model.trim="form.lardingPageUrl" />
        </el-form-item>
        <el-form-item label="帮助中心" prop="helpCenter">
          <el-input v-model.trim="form.helpCenter" />
        </el-form-item>
        <el-form-item label="公告中心" prop="noticeCenter">
          <el-input v-model.trim="form.noticeCenter" />
        </el-form-item>
        <el-form-item label="公告中心数据源" prop="noticeUrl">
          <el-input v-model.trim="form.noticeUrl" />
        </el-form-item>
        <el-form-item label="关于我们" prop="aboutUs">
          <el-input v-model.trim="form.aboutUs" />
        </el-form-item>
        <el-form-item label="用户协议" prop="userAgreemen">
          <el-input v-model.trim="form.userAgreemen" />
        </el-form-item>
        <el-form-item label="隐私政策" prop="privacy">
          <el-input v-model.trim="form.privacy" />
        </el-form-item>
        <el-form-item label="商务合作" prop="cooperation">
          <el-input v-model.trim="form.cooperation" />
        </el-form-item>
        <el-form-item label="使用条款" prop="instructions">
          <el-input v-model.trim="form.instructions" />
        </el-form-item>
        <el-form-item label="费率说明" prop="feeExplain">
          <el-input v-model.trim="form.feeExplain" />
        </el-form-item>
        <el-form-item label="VIP规则说明" prop="vipRuleExplain">
          <el-input v-model.trim="form.vipRuleExplain" />
        </el-form-item>
        <el-form-item label="跟单规则" prop="copyRule">
          <el-input v-model.trim="form.copyRule" />
        </el-form-item>
        <el-form-item label="跟单申请协议" prop="copyAgreement">
          <el-input v-model.trim="form.copyAgreement" />
        </el-form-item>
        <el-form-item label="合约协议" prop="contractAgreement">
          <el-input v-model.trim="form.contractAgreement" />
        </el-form-item>
        <el-form-item label="免责声明" prop="disclaimer">
          <el-input v-model.trim="form.disclaimer" />
        </el-form-item>
        <el-form-item label="风险提示" prop="riskWarning">
          <el-input v-model.trim="form.riskWarning" />
        </el-form-item>
        <el-form-item label="谷歌验证器ios" prop="iosGoogleDownload">
          <el-input v-model.trim="form.iosGoogleDownload" />
        </el-form-item>
        <el-form-item label="谷歌验证器android" prop="androidGoogleDownload">
          <el-input v-model.trim="form.androidGoogleDownload" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input value="勿动" disabled />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from './api';
import { tenantInfo } from '@/common/publicApi';

const INTRODUCTION_TEXT = '前台统一外链配置包：帮助中心、公告中心、公告中心数据源、用户协议、隐私政策、下载落地页、Google Authenticator 下载、VIP规则说明、跟单规则/协议、合约协议、免责声明、风险提示等链接';
const LANG_OPTIONS = [
  { value: 'zh', label: '简体中文' },
  { value: 'en', label: 'English' },
  { value: 'hk', label: '繁體中文' },
  { value: 'vi', label: 'Tiếng Việt' }
];

const createDefaultForm = () => ({
  id: '',
  confKey: '',
  tenantId: '',
  lang: '',
  liveAuthType: '',
  lardingPageUrl: '',
  helpCenter: '',
  noticeCenter: '',
  noticeUrl: '',
  aboutUs: '',
  userAgreemen: '',
  privacy: '',
  cooperation: '',
  instructions: '',
  feeExplain: '',
  vipRuleExplain: '',
  copyRule: '',
  copyAgreement: '',
  contractAgreement: '',
  disclaimer: '',
  riskWarning: '',
  iosGoogleDownload: '',
  androidGoogleDownload: ''
});

export default {
  name: 'FunctionUrlConfigSetting',
  data() {
    return {
      list: [],
      tenantList: [],
      dialogVisible: false,
      dialogMode: 'create',
      saving: false,
      langOptions: LANG_OPTIONS,
      form: createDefaultForm(),
      rules: {
        tenantId: [{ required: true, message: '请选择租户', trigger: 'change' }],
        lang: [{ required: true, message: '请选择语言', trigger: 'change' }]
      }
    };
  },
  methods: {
    loadList() {
      api.getList().then(res => {
        const data = res && res.data;
        this.list = Array.isArray(data) ? data : [];
      });
    },
    loadTenantList() {
      tenantInfo().then(res => {
        if (res.code === 0) {
          this.tenantList = Array.isArray(res.data) ? res.data : [];
        }
      });
    },
    getTenantName(tenantId) {
      const target = this.tenantList.find(item => String(item.id) === String(tenantId));
      return target ? target.tenantName : tenantId;
    },
    getLangLabel(lang) {
      const target = this.langOptions.find(item => item.value === lang);
      return target ? target.label : lang;
    },
    openCreate() {
      this.dialogMode = 'create';
      this.form = createDefaultForm();
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogMode = 'edit';
      this.form = {
        ...createDefaultForm(),
        ...row
      };
      this.dialogVisible = true;
    },
    handleDialogClose() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.form = createDefaultForm();
    },
    buildPayload() {
      return {
        ...this.form,
        tenantId: this.form.tenantId === '' ? '' : Number(this.form.tenantId),
        confIntroduction: INTRODUCTION_TEXT
      };
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        this.saving = true;
        const payload = this.buildPayload();
        const request = this.dialogMode === 'create'
          ? api.addConfig(payload)
          : api.updateConfig(payload);
        request.then(() => {
          this.$message.success(this.dialogMode === 'create' ? '新增成功' : '保存成功');
          this.dialogVisible = false;
          this.loadList();
        }).finally(() => {
          this.saving = false;
        });
      });
    },
    handleDelete(row) {
      this.$confirm('确认删除这条配置吗？', '提示', {
        type: 'warning'
      }).then(() => {
        api.deleteConfig(row.confKey).then(() => {
          this.$message.success('删除成功');
          this.loadList();
        });
      });
    }
  },
  mounted() {
    this.loadTenantList();
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.tips {
  margin-bottom: 16px;
  color: #606266;
  line-height: 22px;
}

.page-actions {
  margin-bottom: 16px;
}

.config-table {
  width: 100%;
}

.danger-text {
  color: #f56c6c;
}
</style>
